var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.lob === "AI"
        ? [
            _vm.masterFlag
              ? _c("ai-master-basic-tab", {
                  ref: "tabAIBasicMaster",
                  attrs: {
                    context: _vm.context,
                    action: _vm.action,
                    "view-source": "salesDetail",
                    "booking-agent-visible": _vm.bookingAgentVisible
                  }
                })
              : _c("ai-basic-tab", {
                  ref: "tabAIBasic",
                  attrs: {
                    context: _vm.context,
                    action: _vm.action,
                    "view-source": "salesDetail",
                    "booking-agent-visible": _vm.bookingAgentVisible
                  }
                })
          ]
        : _vm.lob === "AE"
        ? [
            _vm.masterFlag
              ? [
                  _vm.showUiCustom
                    ? _c("ae-tab-master-UICustom", {
                        ref: "tabAEBasicMaster",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "view-source": "salesDetail"
                        }
                      })
                    : _c("ae-master-basic-tab", {
                        ref: "tabAEBasicMaster",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "view-source": "salesDetail"
                        }
                      })
                ]
              : [
                  _vm.showUiCustom
                    ? _c("ae-tab-general-UICustom", {
                        ref: "tabAEBasic",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "view-source": "salesDetail"
                        }
                      })
                    : _c("ae-basic-tab", {
                        ref: "tabAEBasic",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "view-source": "salesDetail"
                        }
                      })
                ]
          ]
        : _vm.lob === "SI"
        ? [
            _vm.masterFlag
              ? _c("si-master-basic-tab", {
                  ref: "tabSiBasicMaster",
                  attrs: {
                    context: _vm.context,
                    action: _vm.action,
                    "view-source": "salesDetail",
                    "booking-agent-visible": _vm.bookingAgentVisible
                  }
                })
              : _c("si-basic-tab", {
                  ref: "tabSiBasic",
                  attrs: {
                    context: _vm.context,
                    action: _vm.action,
                    "view-source": "salesDetail",
                    "booking-agent-visible": _vm.bookingAgentVisible
                  }
                })
          ]
        : _vm.lob === "SE"
        ? [
            _vm.masterFlag
              ? [
                  _vm.showUiCustom
                    ? _c("tab-booking-master-UICustom", {
                        ref: "tabBookingMaster",
                        staticClass: "se-basic-tab",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "view-source": "salesDetail"
                        }
                      })
                    : _c("tab-booking-master", {
                        ref: "tabBookingMaster",
                        staticClass: "se-basic-tab",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "view-source": "salesDetail"
                        }
                      })
                ]
              : [
                  _vm.showUiCustom
                    ? _c("tab-booking-FCLUICustom", {
                        ref: "tabBookingFCL",
                        staticClass: "se-basic-tab",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "view-source": "salesDetail"
                        }
                      })
                    : _c("tab-booking-fcl", {
                        ref: "tabBookingFCL",
                        staticClass: "se-basic-tab",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "view-source": "salesDetail"
                        }
                      })
                ]
          ]
        : _vm.lob === "RE" || _vm.lob === "RI"
        ? [
            _vm.masterFlag
              ? _c("re-tab-booking-master", {
                  ref: "reTabBookingMaster",
                  attrs: {
                    context: _vm.context,
                    action: _vm.action,
                    "view-source": "salesDetail"
                  }
                })
              : _c("re-tab-booking-fcl", {
                  ref: "reTabBookingFcl",
                  attrs: {
                    context: _vm.context,
                    action: _vm.action,
                    "view-source": "salesDetail"
                  }
                })
          ]
        : _vm.lob === "IE"
        ? [
            _vm.job.containerLoadType === "TT"
              ? _c("tab-gathering-trailer-base", {
                  ref: "tabGatheringTrailerBase",
                  attrs: { context: _vm.context, action: _vm.action }
                })
              : _vm._e(),
            _vm.job.containerLoadType === "CL"
              ? _c("tab-less-than-carload-base", {
                  ref: "tabLessThanCarloadBase",
                  attrs: { context: _vm.context, action: _vm.action }
                })
              : _vm._e(),
            _vm.job.containerLoadType === "IC"
              ? _c("tab-international-card-base", {
                  ref: "tabInternationalCard",
                  attrs: { context: _vm.context, action: _vm.action }
                })
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }